import { useCallback, useEffect, useState } from "react";
import { Pricelist, fetchPricelistList } from "../api/pricelist";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

export const usePricelistList = (enabled = true) => {
  const [data, setData] = useState<Pricelist[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refetch = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchPricelistList(true)
      .then((items) => {
        if (!cancelled) {
          setData(items);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(getApiErrorMessage(err, "Не удалось загрузить тарифы"));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, reloadToken]);

  return { data, loading, error, refetch };
};
